import Request from '@hotmart-org-ca/request';

import './interceptor';

Request.register(`${process.env.BIOMETRIC_IDENTITY_API}/api/rest/v1/mobile`, {
  get: {
    'biometric.session.check': '/session/check',
  },
});

Request.register(`${process.env.DOCUMENTS_VALIDATIONS_API}/rest/v1/mobile`, {
  get: {
    'document.income': '/documentReview/income',
  },
  post: {
    'biometric.send.review': '/documentReview',
  },
});
